export default {
  state: {
    numberOfCompletedSteps: 0,
  },
  mutations: {
    setNumberOfCompletedSteps(state, numberOfCompletedSteps) {
      state.numberOfCompletedSteps = numberOfCompletedSteps;
    },
  },
  actions: {
    updateCompletedSteps({ commit }, stepsCompleted) {
      commit('setNumberOfCompletedSteps', stepsCompleted);
    },
  },
  getters: {
    numberOfCompletedSteps: state => state.numberOfCompletedSteps,
  },
};
